import React, { useState } from 'react';
import FaqButton from './FaqButton';
import FaqDrawer from './FaqDrawer';

export const Faq: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  return (
    <>
      {!isDrawerOpen && <FaqButton onOpenDrawer={handleOpenDrawer} />}
      {isDrawerOpen && <FaqDrawer isOpen={isDrawerOpen} onClose={handleCloseDrawer} />}
    </>
  );
};

export default Faq;
